module.exports = __webpack_public_path__ + "static/img/adams.50af35e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/adams.jpg
// module id = 455
// module chunks = 11